export const QUERY = {
	CODE: 'code',
	OIDC_TOKEN: 'id_token',
	ORGANIZATION: 'orgId',
	REDIRECT: 'redirect',
	REGION: 'region',
	SALESFORCE_REAUTHENTICATION: 'sfReauth',
	STATE: 'state',
	TARGET_ORGANIZATION: 'targetOrganization',
	TARGET_ROUTE: 'targetRoute'
};
